// Analytics Event Names
// {object}_{action}_{outcome}
export enum ANALYTICS_EVENTS {
  // Load events (fired on component mount)
  LOAN_SELECTOR_LOAD = 'loan_selector_load',
  SIGNUP_LOAD = 'signup_load',
  LOGIN_LOAD = 'login_load',
  DISCLOSURES_LOAD = 'disclosures_load',
  PERSONAL_INFO_LOAD = 'personal_info_load',
  SECURE_INFO_LOAD = 'secure_info_load',
  PREQUAL_LANDING_LOAD = 'prequal_landing_load',
  PREQUAL_BANK_DETAILS_LOAD = 'prequal_bank_details_load',
  PHONE_VERIFICATION_LOAD = 'phone_verification_load',
  IDENTITY_VERIFICATION_LOAD = 'identity_verification_load',
  TILA_DISPLAY_LOAD = 'tila_display_load',
  FIRST_PAYMENT_DATE_LOAD = 'first_payment_date_load',
  AGREEMENTS_LOAD = 'agreements_load',
  FUNDING_DEBIT_CARD_LOAD = 'funding_debit_card_load',
  FUNDING_DEBIT_ADDRESS_LOAD = 'funding_debit_address_load',
  FUNDING_METHOD_SELECTION_LOAD = 'funding_method_selection_load',
  FUNDING_EFTA_LOAD = 'funding_efta_load',

  // Submit events (fired on form submission attempt)
  LOAN_SELECTOR_SUBMIT = 'loan_selector_submit',
  SIGNUP_SUBMIT = 'signup_submit',
  LOGIN_SUBMIT = 'login_submit',
  DISCLOSURES_SUBMIT = 'disclosures_submit',
  PERSONAL_INFO_SUBMIT = 'personal_info_submit',
  SECURE_INFO_SUBMIT = 'secure_info_submit',
  PREQUAL_LANDING_SUBMIT = 'prequal_landing_submit',
  PREQUAL_BANK_DETAILS_SUBMIT = 'prequal_bank_details_submit',
  PHONE_VERIFICATION_SUBMIT = 'phone_verification_submit',
  IDENTITY_VERIFICATION_SUBMIT = 'identity_verification_submit',
  TILA_DISPLAY_SUBMIT = 'tila_display_submit',
  FIRST_PAYMENT_DATE_SUBMIT = 'first_payment_date_submit',
  AGREEMENTS_SUBMIT = 'agreements_submit',
  FUNDING_DEBIT_CARD_SUBMIT = 'funding_debit_card_submit',
  FUNDING_DEBIT_ADDRESS_SUBMIT = 'funding_debit_address_submit', // reserved, not currently in use
  FUNDING_EFTA_SUBMIT = 'funding_efta_submit',

  // Success events (fired on successful API response)
  LOAN_SELECTOR_SUCCESS = 'loan_selector_success',
  SIGNUP_SUCCESS = 'signup_success',
  LOGIN_SUCCESS = 'login_success',
  DISCLOSURES_SUCCESS = 'disclosures_success',
  PERSONAL_INFO_SUCCESS = 'personal_info_success',
  SECURE_INFO_SUCCESS = 'secure_info_success',
  PREQUAL_LANDING_SUCCESS = 'prequal_landing_success',
  PREQUAL_BANK_DETAILS_SUCCESS = 'prequal_bank_details_success',
  PHONE_VERIFICATION_SUCCESS = 'phone_verification_success',
  IDENTITY_VERIFICATION_SUCCESS = 'identity_verification_success',
  TILA_DISPLAY_SUCCESS = 'tila_display_success',
  FIRST_PAYMENT_DATE_SUCCESS = 'first_payment_date_success',
  AGREEMENTS_SUCCESS = 'agreements_success',
  AGREEMENTS_FETCH_SUCCESS = 'agreements_fetch_success',
  FUNDING_DEBIT_CARD_SUCCESS = 'funding_debit_card_success',
  FUNDING_DEBIT_ADDRESS_SUCCESS = 'funding_debit_address_success', // reserved, not currently in use
  FUNDING_EFTA_SUCCESS = 'funding_efta_success',

  // Error events (fired on API errors)
  LOAN_SELECTOR_ERROR = 'loan_selector_error',
  SIGNUP_ERROR = 'signup_error',
  LOGIN_ERROR = 'login_error',
  DISCLOSURES_ERROR = 'disclosures_error',
  PERSONAL_INFO_ERROR = 'personal_info_error',
  SECURE_INFO_ERROR = 'secure_info_error',
  PREQUAL_LANDING_ERROR = 'prequal_landing_error',
  PREQUAL_BANK_DETAILS_ERROR = 'prequal_bank_details_error',
  PHONE_VERIFICATION_ERROR = 'phone_verification_error',
  IDENTITY_VERIFICATION_ERROR = 'identity_verification_error',
  TILA_DISPLAY_ERROR = 'tila_display_error',
  FIRST_PAYMENT_DATE_ERROR = 'first_payment_date_error',
  AGREEMENTS_ERROR = 'agreements_error',
  AGREEMENTS_FETCH_ERROR = 'agreements_fetch_error',
  FUNDING_DEBIT_CARD_ERROR = 'funding_debit_card_error',
  FUNDING_DEBIT_ADDRESS_ERROR = 'funding_debit_address_error', // reserved, not currently in use
  FUNDING_EFTA_ERROR = 'funding_efta_error', // reserved, not currently in use

  // Validation error events (fired on frontend validation failure)
  LOAN_SELECTOR_VALIDATION_ERROR = 'loan_selector_validation_error',
  SIGNUP_VALIDATION_ERROR = 'signup_validation_error',
  LOGIN_VALIDATION_ERROR = 'login_validation_error',
  DISCLOSURES_VALIDATION_ERROR = 'disclosures_validation_error',
  PERSONAL_INFO_VALIDATION_ERROR = 'personal_info_validation_error',
  SECURE_INFO_VALIDATION_ERROR = 'secure_info_validation_error',
  PREQUAL_LANDING_VALIDATION_ERROR = 'prequal_landing_validation_error',
  PREQUAL_BANK_DETAILS_VALIDATION_ERROR = 'prequal_bank_details_validation_error',
  PHONE_VERIFICATION_VALIDATION_ERROR = 'phone_verification_validation_error',
  IDENTITY_VERIFICATION_VALIDATION_ERROR = 'identity_verification_validation_error',
  TILA_DISPLAY_VALIDATION_ERROR = 'tila_display_validation_error', // reserved, not currently in use
  FIRST_PAYMENT_DATE_VALIDATION_ERROR = 'first_payment_date_validation_error',
  AGREEMENTS_VALIDATION_ERROR = 'agreements_validation_error',
  FUNDING_DEBIT_CARD_VALIDATION_ERROR = 'funding_debit_card_validation_error', // reserved, not currently in use
  FUNDING_DEBIT_ADDRESS_VALIDATION_ERROR = 'funding_debit_address_validation_error',
  FUNDING_EFTA_VALIDATION_ERROR = 'funding_efta_validation_error',

  // Funding flow action events
  FUNDING_DEBIT_SKIP = 'funding_debit_skip',
  FUNDING_METHOD_SELECT_MAIL = 'funding_method_select_mail',
  FUNDING_METHOD_SELECT_DEBIT = 'funding_method_select_debit',
  FUNDING_METHOD_SELECT_ACH = 'funding_method_select_ach',
  FUNDING_DEBIT_INELIGIBLE_INITIAL = 'funding_debit_ineligible_initial',
  FUNDING_DEBIT_INELIGIBLE_AFTER_ENTRY = 'funding_debit_ineligible_after_entry',

  // Spousal relationship events
  SPOUSAL_RELATIONSHIP_LOAD = 'spousal_relationship_load',
  SPOUSAL_RELATIONSHIP_SUBMIT = 'spousal_relationship_submit',
  SPOUSAL_RELATIONSHIP_SUCCESS = 'spousal_relationship_success',
  SPOUSAL_RELATIONSHIP_ERROR = 'spousal_relationship_error',
  SPOUSAL_RELATIONSHIP_VALIDATION_ERROR = 'spousal_relationship_validation_error',

  // Prequal offer events
  OFFER_VIEW = 'offer_view',

  // A/B Testing
  AB_TEST_ASSIGNMENT = 'experiment_impression',

  // Test Event
  TEST_EVENT = 'test_event',
} 